module.exports = __webpack_public_path__ + "media/images/icons/vendors/large/venues-586efdcf875aa0fb9974fc3a5ad3c279.png";